//@flow
import { enqueueSnackbar } from "notistack";
import * as React from 'react'
import { useTranslation } from "react-i18next";
import { handleAxiosErrors } from "../../../helpers/errorHandling";
import useUserData from "../../../hooks/user/useUserData";
import {downloadFile} from "../../../helpers/fileHandle";
import { AXIOS_ERROR_MESSAGE } from "../../../locales/components/namespaces";
import ContentLoader from "../contentLoader/contentLoader";

type Props = {
    url: string,
    filename: string,
    children: React.Node,
}

export const AuthenticatedLink = (props: Props) => {
    const {url, filename, children, ...otherProps} = props
    const {token} = useUserData()
    const {t} = useTranslation(AXIOS_ERROR_MESSAGE)
    const headers = {'Authorization': `Bearer ${token}`}
    const [loading, setLoading] = React.useState(false)
    const handleAction = async () => {
        setLoading(true)
        try {
            const result = await fetch(url, {
                headers: headers
            })
            if(!result.ok) {
                const status = result.status
                enqueueSnackbar(t(status === 500 ? 'No data found or an error occurred!' : status === 404 ? 'No data found!' : 'An error occurred!'), {
                    variant: 'error',
                    autoHideDuration: 3000,
                })
                setLoading(false)
            } else {
                const blob = await result.blob()
                const href = window.URL.createObjectURL(blob)
                downloadFile(href, filename);
                setLoading(false)
            }
        } catch(error) {
            setLoading(false)
            enqueueSnackbar(handleAxiosErrors(error, t('No data found or an error occurred!'), {
                variant: 'error',
                autoHideDuration: 3000,
            }))
        }
    }
    return (
        <>
            <a
                onClick={handleAction}
                {...otherProps}
            >
                {children}
            </a>
            {loading && <ContentLoader loading={loading} withBackDrop useCircularLoader message={t('Downloading...')}/>}
        </>
    )
}